
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as teamKlq_45KEeMDvX1jnL1VNpF4nY_450mFRDRaCQnozT1LynaQMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/team.vue?macro=true";
import { default as index7WNSYpRvf7FwlsidCV5F9QkIXrrF_45XniTGgjKvw_6JUMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/index.vue?macro=true";
import { default as showcasebuaoI8mmg0BEmFoBsACpwq3bcXDOjC3Hxxxk1ZtM6zYMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/showcase.vue?macro=true";
import { default as templatesqN2jXyNw4y8YHJMQsxPyht80_45ezIugEAo_45sh7KmBXyoMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/templates.vue?macro=true";
import { default as indexQJqWlyjC08_fcT9qtPyFZNhYllkPmyjlQYM9Hkb9BysMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/blog/index.vue?macro=true";
import { default as design_45kitXnDUYWRI99FGiZmYb1J46nqc6qqNtEMgU5qJtiTStZIMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/design-kit.vue?macro=true";
import { default as jobs6tx0bIc7ppPAtphc_ilPeSzArFe1HqeqAKJweFcY8y8Meta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/jobs.vue?macro=true";
import { default as supportCncEjpddNtls1zlACogNZirgvV9xHx6jkDhgP_456pX0EMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/support.vue?macro=true";
import { default as sponsorssbg4FWbfv0TixDzUOjTeoL5PtVhCU5P6fUgHGs9IBlQMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/sponsors.vue?macro=true";
import { default as indexAZ2kukjGBMsk6h2N9RAwBSt5_45De3cbV_CJQyOclagkoMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/agencies/index.vue?macro=true";
import { default as _91slug_93gDQ0NnDnrrhURQaOcIu5vS7VRvuiiABr7D4txfMLVv8Meta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/agencies/[slug].vue?macro=true";
import { default as enterpriseL_UmtKGFRi7LujNr11y6JbaDtZHwpeDjsxiTq4fIhe8Meta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise.vue?macro=true";
import { default as newsletteroA5p6R6ghQzNyMYxrGzbV9Uv2ULleWi7FAyLvXlm_9UMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/newsletter.vue?macro=true";
import { default as _91slug_93A0yQGPE0h91tj9jq2P_WHZQkuoUmIFkhg4sj2TiLlYQMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/blog/[slug].vue?macro=true";
import { default as index7RLJar3bi5n_XDI8KuePFEPYLl56kA7gcqpwwF8B1IIMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/deploy/index.vue?macro=true";
import { default as _91slug_93gZPrePEZvUZp4IBg0aWc48j10rIpWtY2zVEvYdZHYdMMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/deploy/[slug].vue?macro=true";
import { default as indexh166wR2ciQDDNLKfavs53hshYqBGMZHFLmZF9a56mH8Meta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/modules/index.vue?macro=true";
import { default as video_45coursesZy5fOBPm6tz_45A1c3k7AeRMmNpwhpfEpURN5BmEpmNz4Meta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/video-courses.vue?macro=true";
import { default as _91_46_46_46slug_93ahjdGOjT8Da8C1UADltb2c4U0w92qAxI_45rOsc_45q6IaEMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/docs/[...slug].vue?macro=true";
import { default as _91slug_93ETCgnv_452_45MjNhxIWRkODrT7Uqg81PP_nXz0rAse3PkgMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/modules/[slug].vue?macro=true";
import { default as component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqli_a91bc8a907ef4658a3a2d26fc56820fe/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g } from "/Users/q/code/nodejscn/nuxt/src/nuxt.com/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.13.10_better-sqli_a91bc8a907ef4658a3a2d26fc56820fe/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "team",
    path: "/team",
    meta: teamKlq_45KEeMDvX1jnL1VNpF4nY_450mFRDRaCQnozT1LynaQMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/team.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index7WNSYpRvf7FwlsidCV5F9QkIXrrF_45XniTGgjKvw_6JUMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/index.vue")
  },
  {
    name: "showcase",
    path: "/showcase",
    meta: showcasebuaoI8mmg0BEmFoBsACpwq3bcXDOjC3Hxxxk1ZtM6zYMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/showcase.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: templatesqN2jXyNw4y8YHJMQsxPyht80_45ezIugEAo_45sh7KmBXyoMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/templates.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexQJqWlyjC08_fcT9qtPyFZNhYllkPmyjlQYM9Hkb9BysMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/blog/index.vue")
  },
  {
    name: "design-kit",
    path: "/design-kit",
    meta: design_45kitXnDUYWRI99FGiZmYb1J46nqc6qqNtEMgU5qJtiTStZIMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/design-kit.vue")
  },
  {
    name: "enterprise",
    path: "/enterprise",
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise.vue"),
    children: [
  {
    name: "enterprise-jobs",
    path: "jobs",
    meta: jobs6tx0bIc7ppPAtphc_ilPeSzArFe1HqeqAKJweFcY8y8Meta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/jobs.vue")
  },
  {
    name: "enterprise-support",
    path: "support",
    meta: supportCncEjpddNtls1zlACogNZirgvV9xHx6jkDhgP_456pX0EMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/support.vue")
  },
  {
    name: "enterprise-sponsors",
    path: "sponsors",
    meta: sponsorssbg4FWbfv0TixDzUOjTeoL5PtVhCU5P6fUgHGs9IBlQMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/sponsors.vue")
  },
  {
    name: "enterprise-agencies",
    path: "agencies",
    meta: indexAZ2kukjGBMsk6h2N9RAwBSt5_45De3cbV_CJQyOclagkoMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/agencies/index.vue")
  },
  {
    name: "enterprise-agencies-slug",
    path: "agencies/:slug()",
    meta: _91slug_93gDQ0NnDnrrhURQaOcIu5vS7VRvuiiABr7D4txfMLVv8Meta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/enterprise/agencies/[slug].vue")
  }
]
  },
  {
    name: "newsletter",
    path: "/newsletter",
    meta: newsletteroA5p6R6ghQzNyMYxrGzbV9Uv2ULleWi7FAyLvXlm_9UMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/newsletter.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93A0yQGPE0h91tj9jq2P_WHZQkuoUmIFkhg4sj2TiLlYQMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/blog/[slug].vue")
  },
  {
    name: "deploy",
    path: "/deploy",
    meta: index7RLJar3bi5n_XDI8KuePFEPYLl56kA7gcqpwwF8B1IIMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/deploy/index.vue")
  },
  {
    name: "deploy-slug",
    path: "/deploy/:slug()",
    meta: _91slug_93gZPrePEZvUZp4IBg0aWc48j10rIpWtY2zVEvYdZHYdMMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/deploy/[slug].vue")
  },
  {
    name: "modules",
    path: "/modules",
    meta: indexh166wR2ciQDDNLKfavs53hshYqBGMZHFLmZF9a56mH8Meta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/modules/index.vue")
  },
  {
    name: "video-courses",
    path: "/video-courses",
    meta: video_45coursesZy5fOBPm6tz_45A1c3k7AeRMmNpwhpfEpURN5BmEpmNz4Meta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/video-courses.vue")
  },
  {
    name: "docs-slug",
    path: "/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93ahjdGOjT8Da8C1UADltb2c4U0w92qAxI_45rOsc_45q6IaEMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/docs/[...slug].vue")
  },
  {
    name: "modules-slug",
    path: "/modules/:slug()",
    meta: _91slug_93ETCgnv_452_45MjNhxIWRkODrT7Uqg81PP_nXz0rAse3PkgMeta || {},
    component: () => import("/Users/q/code/nodejscn/nuxt/src/nuxt.com/app/pages/modules/[slug].vue")
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/getting-started",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/guide/concepts",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/guide/directory-structure",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/guide/going-further",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/guide/going-further/edge-release-channel",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/bridge",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/migration",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/api/components",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/api/composables",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/api/utils",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/api/kit",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/api/commands",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/api/advanced",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/api/configuration/nuxt-config",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/examples",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/examples/features",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/examples/routing",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/examples/advanced",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/examples/experimental",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/community",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/community/nuxt-community",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/guide/recipes",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/guide/best-practices",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/docs/guide/going-further/custom-routing",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  },
  {
    name: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3gMeta?.name,
    path: "/support/us",
    component: component_45stub5nwaQOokmPQj8glS6qA7slR_vRlKM1_45n4bv4xjs_b3g
  }
]